module.exports = __webpack_public_path__ + "8a04e516a50aedff7a193477ff86dd40.png";